import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "Variables SUPABASE_URL ou SUPABASE_ANON_KEY manquantes. Copie client/.env.example vers client/.env et renseigne les valeurs (Dashboard Supabase → Project Settings → API)."
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);